import xssFilters from 'xss-filters'

export const cleanResponseService = stripedArray => {
  const cleanArray = stripedArray.map(data => {
    const _isString = obj => typeof obj === 'string' || obj instanceof String
    const _clean = obj => (_isString(obj)) ? xssFilters.inHTMLData(obj) : obj
    let newObj = {}

    if (_isString(data)) return _clean(data)

    Object.keys(data).forEach(key => {
      newObj[key] = (typeof data[key] !== 'undefined' && data[key] !== null) ? _clean(data[key]) : ''
    })

    return newObj
  })

  return cleanArray
}



// WEBPACK FOOTER //
// ./src/services/cleanResponseService.js